module.exports = __webpack_public_path__ + "img/imgslider1.a4bf066f.png";